import React from 'react';

import Container from './Container';
import { SummaryCardProvider } from './Context';

const AccordionSummaryCardComponent = () => {
  return (
    <SummaryCardProvider>
      <Container />
    </SummaryCardProvider>
  );
};

export default AccordionSummaryCardComponent;
